import { createContext, useContext } from 'react'

import type { ManualCandidate } from '@/lib/api/einvoice-api'

/** Lets a dialog nested in the pending card hand over to "Đã xuất trên MISA"
 *  with one MISA-website invoice already chosen. Absent outside that card. */
const OpenManualIssueContext = createContext<
    ((candidate: ManualCandidate) => void) | undefined
>(undefined)

export const OpenManualIssueProvider = OpenManualIssueContext.Provider

export const useOpenManualIssue = () => useContext(OpenManualIssueContext)
